/* eslint-disable no-console */
import enviro from 'enviro';
import kebabCase from 'hs-lodash/kebabCase';
import Raven from 'Raven';
export default class Logger {
  constructor(isProd = enviro.isProd(), isDeployed = enviro.deployed(), fingerprint = []) {
    this.isProd = isProd;
    this.isDeployed = isDeployed;
    this.fingerprint = fingerprint;
  }

  debug(message, context = {}) {
    this.log('debug', message, context);

    if (!this.isProd) {
      console.debug(message, context);
    }
  }

  info(message, context = {}) {
    this.log('info', message, context);

    if (!this.isProd) {
      console.info(message, context);
    }
  }

  warn(message, context = {}) {
    this.log('warning', message, context);

    if (!this.isProd) {
      console.warn(message, context);
    }
  }

  error(message, context = {}) {
    this.log('error', message, context);

    if (!this.isProd) {
      console.error(message, context);
    }
  }

  critical(message, context = {}) {
    this.log('critical', message, context);

    if (!this.isProd) {
      console.error(message, context);
    }
  }

  getEnvironment() {
    return this.isProd ? 'prod' : 'qa';
  }

  log(level, message, context = {}) {
    const ravenOptions = Object.assign({}, context);
    const environment = this.getEnvironment();

    if (!ravenOptions.level) {
      ravenOptions.level = level;
    }

    if (!ravenOptions.fingerprint) {
      ravenOptions.fingerprint = [environment, ...this.fingerprint].concat([kebabCase(message)]);
    }

    if (level !== 'debug') {
      this.reportToSentry(`[${environment.toUpperCase()}] ${message}`, ravenOptions);
    }
  }

  reportToSentry(message, ravenOptions) {
    if (!this.isDeployed) {
      return;
    }

    if (!this.isProd) {
      console.log(`[${ravenOptions.level}] (reported to Sentry) %s, %o`, message, ravenOptions);
    }

    Raven.captureMessage(message, ravenOptions);
  }

  static getLogger(name, loggerOptions = {}) {
    loggerOptions = Object.assign({}, {
      isProd: enviro.isProd(),
      isDeployed: enviro.deployed(),
      fingerprint: [name]
    }, {}, loggerOptions);
    return new Logger(loggerOptions.isProd, loggerOptions.isDeployed, loggerOptions.fingerprint);
  }

}